export const QUERY_TYPE_ORDERS_WITHOUT_COLLECTION = 'orders-without-collection'
